import React from 'react'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import styled from 'styled-components'
import DocumentTitle from 'react-document-title'
import MatchPlayer from '../../components/MatchPlayer'
import Telemetry from '../../models/Telemetry.js'
import TelemetryWorker from '../../models/Telemetry.worker.js'
import { getMapAsset } from '../../components/MatchPlayer/Map/BackgroundLayer'

const Message = styled.p`
    text-align: center;
`

class Match extends React.Component {
    state = {
        rawTelemetry: null,
        telemetry: null,
        telemetryLoaded: false,
        telemetryError: false,
        rosters: null,
        globalState: null,
        playerNames: null,
    }

    componentDidMount() {
        if (this.props.data.match) {
            this.loadTelemetry()
            this.preloadMapImage()
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data.match !== this.props.data.match) {
            this.loadTelemetry()
            this.preloadMapImage()
        }
    }

    componentWillUnmount() {
        this.cancelTelemetry()
    }

    preloadMapImage() {
        new Image().src = getMapAsset(this.props.data.match.mapName)
    }

    loadTelemetry = async () => {
        this.cancelTelemetry()

        const { match } = this.props.data

        console.log(`Loading telemetry for match ${match.id}`)

        this.setState({ telemetry: null, telemetryLoaded: false, telemetryError: false })

        this.telemetryWorker = new TelemetryWorker()

        this.telemetryWorker.addEventListener('message', ({ data }) => {
            const { success, error, state, globalState, rawTelemetry } = data

            if (!success) {
                console.error(`Error loading telemetry: ${error}`)
                this.setState({ telemetryError: true })
                return
            }

            const telemetry = Telemetry(state)
            const rosters = telemetry.finalRoster()
            const playerNames = rosters.reduce((acc, roster) => {
                roster.names.forEach(name => {
                    acc[name] = true
                })
                return acc
            }, {})

            this.setState({
                rawTelemetry,
                telemetry,
                telemetryLoaded: true,
                rosters,
                playerNames,
                globalState,
            })
        })

        this.telemetryWorker.postMessage({
            match: this.props.data.match,
            focusedPlayer: null, // We no longer have a focused player by default
        })
    }

    cancelTelemetry = () => {
        if (this.telemetryWorker) {
            this.telemetryWorker.terminate()
            this.telemetryWorker = null
        }
    }

    render() {
        const { data: { loading, error, match } } = this.props
        const { telemetry, rawTelemetry, telemetryLoaded, telemetryError, rosters, globalState, playerNames } = this.state

        let content

        if (loading) {
            content = <Message>Loading...</Message>
        } else if (error || telemetryError) {
            content = <Message>An error occurred :(</Message>
        } else if (!match) {
            content = <Message>Match not found</Message>
        } else if (!telemetryLoaded) {
            content = <Message>Loading telemetry...</Message>
        } else {
            content = <MatchPlayer
                match={match}
                rawTelemetry={rawTelemetry}
                telemetry={telemetry}
                rosters={rosters}
                globalState={globalState}
                playerName={null} // We no longer have a default focused player
                playerNames={playerNames}
            />
        }

        return (
            <React.Fragment>
                <DocumentTitle title="Replay | eWave.gg" />
                {content}
            </React.Fragment>
        )
    }
}

export default graphql(gql`
    query($matchId: String!) {
        match(id: $matchId) {
            id
            shardId
            gameMode
            playedAt
            mapName
            durationSeconds
            telemetryUrl
            players {
                id
                name
                rosterId
                stats {
                    kills
                    winPlace
                }
            }
        }
    }`, {
    options: ({ match }) => ({
        fetchPolicy: 'network-only',
        variables: {
            matchId: match.params.matchId,
        },
    }),
})(Match)


// WEBPACK FOOTER //
// src/routes/Match/index.js